<template>
    <div class="recruit_section01">
        <v-parallax src="../../assets/img/recruit/img_recruit_top.png" :height="300" class="recruit_parallax01">
            <div class="text_container">
                <div class="servicerecruit_top_title_small">다양한 성장의 기회,</div>
                <div class="servicerecruit_top_title_black"><span class="servicerecruit_top_title_red">데이터유니버스</span>와 함께하세요.</div>
            </div>
        </v-parallax>
        <div class="recruit_parallax02">
          <v-img :src="headImg" :height="headHeight">
            <div class="text_container">
                <div class="servicerecruit_top_title_small">다양한 성장의 기회,</div>
                <div class="servicerecruit_top_title_black"><span class="servicerecruit_top_title_red">데이터유니버스</span>와 함께하세요.</div>
            </div>
          </v-img>
        </div>
        <div class="service_submenu">
            <div class="submenu_container">
                <div class="service_submenu_on">
                    채용 안내
                </div>
            </div>
            <div class="service_line"></div>
            <div class="text_container">
              <div class="pc">
                <div class="recruit_subtitle">
                    (주)데이터유니버스는 더 나은 세상이라는 같은 목표를 바라보며 <br>
                    회사와 함께 성장할 긍정적이고 진취적인 마인드를 갖춘 인재를 찾고 있습니다.
                </div>
              </div>
              <div class="phone">
                <div class="recruit_subtitle">
                    (주)데이터유니버스는 더 나은 세상이라는 같은 목표를 <br> 바라보며
                    회사와 함께 성장할 긍정적이고 진취적인 <br> 마인드를 갖춘 인재를 찾고 있습니다.
                </div>
              </div>
            </div>
            <div class="content_line"></div>
        </div>
    </div>
</template>
<script>
import tabletHeadImg from '../../assets/img/mobile/img_recruit_top_tablet@3x.png'
import phoneHeadImg from '../../assets/img/mobile/img_recruit_top@3x.png'
export default {
	name: 'section01',
	computed: {
		headImg () {
			switch (this.$vuetify.breakpoint.name) {
			default: return phoneHeadImg
			case 'sm': return tabletHeadImg
			}
		},
		headHeight () {
			switch (this.$vuetify.breakpoint.name) {
			default: return 140
			case 'sm': return 173
			}
		}
	}
}
</script>
